










































import "material-icons/iconfont/material-icons.css";
import Vue from "vue";
import {
  VBtn,
  VCard,
  VCardText,
  VContainer,
  VOverlay,
  VProgressCircular
} from "vuetify/lib";

export default Vue.extend({
  components: {
    VBtn,
    VCard,
    VCardText,
    VContainer,
    VOverlay,
    VProgressCircular
  },
  props: {
    logout: {
      type: Function,
      required: false
    },
    refresh: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      secondsLeft: 0,
      showTimeout: false,
      refreshOverlay: false,
      startTimeout: {} as ReturnType<typeof setTimeout>,
      intervalTimer: null as null | Worker
    };
  },
  created() {
    window.addEventListener("message", async event => {
      if (
        typeof event.data.token !== "undefined" ||
        event.data.ssoMsg === "Logout"
      ) {
        clearTimeout(this.startTimeout);
        this.intervalTimer?.terminate();
        this.intervalTimer = null;
        if (this.showTimeout) {
          this.showTimeout = false;
        }
      }

      if (event.data.ssoMsg === "Token Expired") {
        this.secondsLeft = Math.floor(
          (this.$vtrs.parsedToken.exp * 1000 - Date.now()) / 1000
        );
        this.startTimeout = setTimeout(async () => {
          if (this.secondsLeft > 0) {
            this.showTimeout = true;
            this.createTimeoutInterval();
          }
        }, 1000);
      }
    });
  },
  methods: {
    createTimeoutInterval(): void {
      this.intervalTimer = this.$vtrs.createWorker(function startTimer() {
        setInterval(() => {
          self.postMessage(1);
        }, 1000);
      }, "startTimer");

      this.intervalTimer.onmessage = e => {
        if (this.secondsLeft === 0) {
          this.showTimeout = false;
          this.logoutFunc();
        } else {
          this.secondsLeft -= e.data;
        }
      };
    },
    async refreshFunc(userInput = false): Promise<void> {
      this.showTimeout = false;

      clearTimeout(this.startTimeout);
      this.intervalTimer?.terminate();
      this.intervalTimer = null;

      if (userInput) {
        this.refreshOverlay = true;
      }

      if (this.refresh) {
        await this.refresh();
      } else {
        const success = await this.$vtrs.refresh();

        if (userInput) {
          this.refreshOverlay = false;
        }
        if (!success) {
          this.logoutFunc();
        }
      }
    },
    async logoutFunc(): Promise<void> {
      this.showTimeout = false;

      clearTimeout(this.startTimeout);
      this.intervalTimer?.terminate();
      this.intervalTimer = null;

      if (this.logout) {
        await this.logout();
      } else {
        await this.$vtrs.logout(true);
        this.$vtrs.redirect(true);
      }
    }
  }
});
